/* eslint-disable react/no-unknown-property */
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../../../../../elements/button'
import { useParams } from 'react-router-dom'
import DataSelection from '../../../../setScope/_components/uploadData/dataSelection'
import { useExperimentApi } from '../../../../../../store/api/hooks/experimentApiHook'
import toast from 'react-hot-toast'
import Loader from '../../../../../../components/loader'
import { SelectedDataTableType } from '../../../../../../_config/types'
import { useExperimentSelector } from '../../../../../../store/selectors/experimentSelector'
import { trackEvent } from '../../../../../../_common/functions'

interface MeasurementModalProps {
    _ref: any
    onContinue: (data: any) => void
    experimentId?: string
}

const RCTMeasurementModal: React.FC<MeasurementModalProps> = ({ _ref, onContinue, experimentId }) => {
    const { t } = useTranslation()
    const params: any = useParams()
    const experiment = useExperimentSelector()
    const experimentAPI: any = useExperimentApi()

    const [working, setWorking] = useState<boolean>(false)

    const [selectedMeasurementTable, setSelectedMeasurementTable] = useState<SelectedDataTableType | null>(null)

    const updateWithMeasurementTableData = () => {
        trackEvent('wizard_measurement_table_selected', { table_name: selectedMeasurementTable?.table?.name })
        if (experiment.data_mappings.delta_measurement_table_name == selectedMeasurementTable?.table.name) {
            onContinue(selectedMeasurementTable)
        } else {
            const paramsData = {
                delta_measurement_table_name: selectedMeasurementTable?.table.name,
                literal: params.experiment,
            }
            setWorking(true)
            experimentAPI.updateExperiment(
                paramsData,
                (data: any) => {
                    setWorking(false)
                    if (onContinue) {
                        onContinue(selectedMeasurementTable)
                    }
                },
                (error: any) => {
                    setWorking(false)
                    toast.error(error?.message)
                },
            )
        }
    }

    useEffect(() => {
        if (_ref?.current) {
            const originalShowModal = _ref.current.showModal
            _ref.current.showModal = function () {
                trackEvent('wizard_measurement_modal_opened', { type: 'rct' })
                setSelectedMeasurementTable(null)
                originalShowModal?.call(this)
                experimentAPI.getExperimentDetails(
                    { literal: params.experiment + '?use_orm=true' },
                    (resp: any) => {},
                    (error: any) => {},
                )
            }

            _ref.current.addEventListener('cancel', () => {
                setSelectedMeasurementTable(null)
            })
        }
    }, [])

    return (
        <dialog ref={_ref} className="modal">
            <div data-testid="measurement-modal" className="modal-box w-[32.042rem]">
                <DataSelection _for="measurement" selectedDataTable={setSelectedMeasurementTable} />

                <div className="flex items-center justify-end my-4 ">
                    <div className="flex items-center gap-3">
                        <Button
                            theme="secondary"
                            size="xs"
                            styleType="outline"
                            onClick={() => {
                                _ref?.current?.close()
                            }}
                        >
                            {t('Cancel')}
                        </Button>
                        <Button
                            theme="secondary"
                            size="xs"
                            className="text-white"
                            disabled={working || !selectedMeasurementTable}
                            onClick={() => {
                                updateWithMeasurementTableData()
                            }}
                        >
                            {working ? <Loader /> : t('NEXT STEP')}
                        </Button>
                    </div>
                </div>
            </div>
            <form method="dialog" className="modal-backdrop">
                <button type="button">{t('close')}</button>
            </form>
        </dialog>
    )
}

export default RCTMeasurementModal
